import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { tcCategoryQueryLinkerSchema } from './tc-category-query-linker-schema';

export const tcCategoryQuerySchema = z.object({
  ...tcCategoryQueryLinkerSchema.shape,
  sku_prefix: z.string(),
  terms_conditions_count: z.number(),
});

export type TcCategoryQuerySchema = z.infer<typeof tcCategoryQuerySchema>;

export const tcCategoryQueryAllSchema = paginatedResponseSchema(tcCategoryQuerySchema);

export type TcCategoryQueryAllSchema = z.infer<typeof tcCategoryQueryAllSchema>;
